import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateProjectComponent } from "./create-project.component";
import { ZoneMapComponent } from "./zone-map/zone-map.component";
import { SharedModule } from "../../shared.module";
import { DirectAccessGuard } from "../../common/services/direct-access-guard";

const routes: Routes = [
  { path: '', component: CreateProjectComponent, canActivate: [DirectAccessGuard] },
]

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    SharedModule
  ],
  exports: [RouterModule],
  declarations: [CreateProjectComponent, ZoneMapComponent]
})
export class CreateProjectRoutingModule { }
